module.exports = __webpack_public_path__ + "assets/img/Super-Obvious-Landing-Page-w960.657a5996.webp";